module.exports = __webpack_public_path__ + "static/media/logo.2a5dc53e.png";